import React from 'react';
import scinetLogo from './scinet-logo.svg';

const Navbar = ({title}) => {
  return (
    <nav>
      <div className='nav-wrapper lime lighten-5'>
        <img src={scinetLogo} alt='SciNet logo' style={{'height':'30px'}}/>
        <span className='brand-logo center blue-text text-darken-4'>{title}</span>
      </div>
    </nav>
  );
};

export default Navbar;
